export const businessTermAdvance = {
  pageView: () => ({
    event_name: 'page_view, journey_start',
    page_name: 'vodapay: business advance: opf: fixed term funding',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website'
  }),

  btaAccordion: (moduleName, accordianState) => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: fixed term funding',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    link_id: `vodapay: business advance: opf: click ${moduleName} accordian ${accordianState}`
  }),

  btaBannerClick: (ctaLabel) => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: fixed term funding',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    link_id: `vodapay: business advance: opf: fixed term funding: banner: ${ctaLabel}`
  }),

  btaBannerCallbackRequest: (ctaLabel) => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: fixed term funding',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    link_id: `vodapay: business advance: opf: fixed term funding: banner: callback request: ${ctaLabel}`
  }),

  btaBannerReApplyJourney: (ctaLabel) => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: fixed term funding',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    link_id: `vodapay: business advance: opf: fixed term funding: banner: re-apply journey: ${ctaLabel}`
  })
};